module.exports = __webpack_public_path__ + "img/Download-app-Images.89f2386.jpg";